import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const fvMovie = document.querySelector('.fv__movie');
const fvLogoA = document.querySelector('.fv__shapedMovie');
const fvLogoCircle = document.querySelector('.fv__layered');
const fvTtlFstLine = document.querySelector('.fv__catch--fstLine');
const fvTtlSecLine = document.querySelector('.fv__catch--secLine');
const fvTtlSub = document.querySelector('.fv__catch--sub');
const aboutTtlFstLine = document.querySelector('.about__ttl--fstLine');
const aboutTtlSecLine = document.querySelector('.about__ttl--secLine');
const aboutCatch = document.querySelector('.about__catch');
const aboutContainer = document.querySelector('.about');
const businessTtlFstLine = document.querySelector('.business__ttl--fstLine');
const businessTtlSecLine = document.querySelector('.business__ttl--secLine');
const businessContainer = document.querySelector('.business');
const businessChart = document.querySelector('.business__chart');
const casesTtlFstLine = document.querySelector('.cases__ttl--fstLine');
const casesTtlSecLine = document.querySelector('.cases__ttl--secLine');
const casesContainer = document.querySelector('.cases');
const companyTtlFstLine = document.querySelector('.company_ceo__ttl--fstLine');
const companyTtlSecLine = document.querySelector('.company_ceo__ttl--secLine');
const companyContainer = document.querySelector('.company_ceo');
const contactTtlFstLine = document.querySelector('.contact__ttl--fstLine');
const contactTtlSecLine = document.querySelector('.contact__ttl--secLine');
const contactContainer = document.querySelector('.contact');

class Top {
  constructor() {
    this.revealFv();
    this.revealText();
  }

  revealFv() {
    const TL = gsap.timeline();
    TL.add(() => fvMovie.classList.add('frameIsShow'), '+=1')
      .add(() => fvLogoA.classList.add('logoIsShow'), '+=0.3')
      .add(() => fvLogoCircle.classList.add('circleIsShow'))
      .add(() => {
        fvTtlFstLine
          .querySelector('.bgRLextendTrigger')
          .classList.add('bgRLextend');
        fvTtlFstLine
          .querySelector('.bgappearTrigger')
          .classList.add('bgappear');
      }, '+=1')
      .add(() => {
        fvTtlSecLine
          .querySelector('.bgRLextendTrigger')
          .classList.add('bgRLextend');
        fvTtlSecLine
          .querySelector('.bgappearTrigger')
          .classList.add('bgappear');
      }, '+=0.3')
      .add(() => fvTtlSub.classList.add('chatchIsShow'), '+=1.2');
  }

  revealText() {
    // Aboutエリア
    const tlAbout = gsap.timeline({
      scrollTrigger: {
        trigger: aboutContainer,
        start: 'top center',
        end: 'bottom bottom',
      },
    });
    tlAbout
      .add(() => {
        aboutTtlFstLine
          .querySelector('.bgRLextendTrigger')
          .classList.add('bgRLextend');
        aboutTtlFstLine
          .querySelector('.bgappearTrigger')
          .classList.add('bgappear');
      })
      .add(() => {
        aboutTtlSecLine
          .querySelector('.bgRLextendTrigger')
          .classList.add('bgRLextend');
        aboutTtlSecLine
          .querySelector('.bgappearTrigger')
          .classList.add('bgappear');
      }, '+=0.3')
      .add(() => {
        aboutCatch.classList.add('fadeIn');
      }, '+=1.2');

    // BUSINESSエリア
    const tlBusiness = gsap.timeline({
      scrollTrigger: {
        trigger: businessContainer,
        start: 'top center',
        end: 'bottom bottom',
      },
    });
    tlBusiness
      .add(() => {
        businessTtlFstLine
          .querySelector('.bgRLextendTrigger')
          .classList.add('bgRLextend');
        businessTtlFstLine
          .querySelector('.bgappearTrigger')
          .classList.add('bgappear');
      })
      .add(() => {
        businessTtlSecLine
          .querySelector('.bgRLextendTrigger')
          .classList.add('bgRLextend');
        businessTtlSecLine
          .querySelector('.bgappearTrigger')
          .classList.add('bgappear');
      }, '+=0.3')
      .add(() => {
        businessChart.classList.add('floatIn');
      }, '+=1.2');

    // CASESエリア
    const tlCases = gsap.timeline({
      scrollTrigger: {
        trigger: casesContainer,
        start: 'top center',
        end: 'bottom bottom',
      },
    });
    tlCases
      .add(() => {
        casesTtlFstLine
          .querySelector('.bgRLextendTrigger')
          .classList.add('bgRLextend');
        casesTtlFstLine
          .querySelector('.bgappearTrigger')
          .classList.add('bgappear');
      })
      .add(() => {
        casesTtlSecLine
          .querySelector('.bgRLextendTrigger')
          .classList.add('bgRLextend');
        casesTtlSecLine
          .querySelector('.bgappearTrigger')
          .classList.add('bgappear');
      }, '+=0.3');

    // COMPANYエリア
    const tlCompany = gsap.timeline({
      scrollTrigger: {
        trigger: companyContainer,
        start: 'top center',
        end: 'bottom bottom',
      },
    });
    tlCompany
      .add(() => {
        companyTtlFstLine
          .querySelector('.bgRLextendTrigger')
          .classList.add('bgRLextend');
        companyTtlFstLine
          .querySelector('.bgappearTrigger')
          .classList.add('bgappear');
      })
      .add(() => {
        companyTtlSecLine
          .querySelector('.bgRLextendTrigger')
          .classList.add('bgRLextend');
        companyTtlSecLine
          .querySelector('.bgappearTrigger')
          .classList.add('bgappear');
      }, '+=0.3');

    // CONTACTエリア
    const tlContact = gsap.timeline({
      scrollTrigger: {
        trigger: contactContainer,
        start: 'top center',
        end: 'bottom bottom',
      },
    });
    tlContact
      .add(() => {
        contactTtlFstLine
          .querySelector('.bgRLextendTrigger')
          .classList.add('bgRLextend');
        contactTtlFstLine
          .querySelector('.bgappearTrigger')
          .classList.add('bgappear');
      })
      .add(() => {
        contactTtlSecLine
          .querySelector('.bgRLextendTrigger')
          .classList.add('bgRLextend');
        contactTtlSecLine
          .querySelector('.bgappearTrigger')
          .classList.add('bgappear');
      }, '+=0.3');
  }
}
export default Top;
